"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocsForCountry = void 0;
var ALL_DOCUMENT_TYPES = [
    "visa",
    "id-card",
    "driving-license",
    "travel-passport",
    "residence-permit",
    "student-id",
    "health-insurance"
];
var ALL_PAID_DOCUMENT_TYPES = [
    "visa",
    "id-card",
    "driving-license",
    "travel-passport",
    "residence-permit",
];
var NO_ID_DOCUMENT_TYPES = [
    "travel-passport",
    "driving-license",
    "residence-permit",
    "visa"
];
var COUNTRIES = [
    'at',
    'be',
    'ch',
    'de',
    'dk',
    'es',
    'fi',
    'fr',
    'gb',
    'it',
    'li',
    'nl',
    'no',
    'se',
    'tr',
    'gr',
    'pt',
    'ie',
    'us',
    // South and Central America
    'pe',
    've',
    'ec',
    'co',
    'gt',
    'ar',
    'cl',
    'mx',
    'pa',
    'br',
    'hn',
    // Asia
    'tw',
    'cn',
];
var SUPPORTED_DOCS_PER_COUNTRY = {
    de: ALL_DOCUMENT_TYPES,
    at: ALL_DOCUMENT_TYPES,
    ch: ALL_DOCUMENT_TYPES,
    be: ALL_DOCUMENT_TYPES,
    nl: ALL_DOCUMENT_TYPES,
    no: ALL_DOCUMENT_TYPES,
    fi: ALL_DOCUMENT_TYPES,
    li: ALL_DOCUMENT_TYPES,
    se: ALL_DOCUMENT_TYPES,
    dk: ALL_DOCUMENT_TYPES,
    es: ALL_PAID_DOCUMENT_TYPES,
    it: ALL_PAID_DOCUMENT_TYPES,
    tr: ALL_PAID_DOCUMENT_TYPES,
    gr: ALL_PAID_DOCUMENT_TYPES,
    pt: ALL_PAID_DOCUMENT_TYPES,
    fr: [
        "visa",
        "id-card",
        "travel-passport",
    ],
    us: [
        "travel-passport",
        "green-card",
        "driving-license",
        "residence-permit",
        "visa"
    ],
    gb: NO_ID_DOCUMENT_TYPES,
    ie: NO_ID_DOCUMENT_TYPES,
    pe: NO_ID_DOCUMENT_TYPES,
    ve: NO_ID_DOCUMENT_TYPES,
    ec: NO_ID_DOCUMENT_TYPES,
    co: NO_ID_DOCUMENT_TYPES,
    gt: NO_ID_DOCUMENT_TYPES,
    ar: NO_ID_DOCUMENT_TYPES,
    cl: NO_ID_DOCUMENT_TYPES,
    mx: NO_ID_DOCUMENT_TYPES,
    pa: NO_ID_DOCUMENT_TYPES,
    br: NO_ID_DOCUMENT_TYPES,
    hn: NO_ID_DOCUMENT_TYPES,
    cn: ALL_PAID_DOCUMENT_TYPES,
    tw: ALL_PAID_DOCUMENT_TYPES,
};
var isKnownCountry = function (country) {
    return COUNTRIES.includes(country);
};
function getDocsForCountry(country) {
    var _a;
    if (isKnownCountry(country)) {
        return (_a = SUPPORTED_DOCS_PER_COUNTRY[country]) !== null && _a !== void 0 ? _a : [];
    }
    return [];
}
exports.getDocsForCountry = getDocsForCountry;
